/**
 * FAQ アコーディオン開閉アニメ制御。
 *
 * <details> のデフォルト挙動では open 属性が削除された瞬間にコンテンツが非表示扱いになり、
 * CSS の transition が動かない (= 閉じが一瞬で終わる)。 そこで summary の click を JS で
 * 横取りし、 開閉の流れを下記のようにコントロールする:
 *
 *   - 閉じる時: open はまだ付いたまま `.is-closing` を付与 → CSS 側で grid-template-rows 0fr +
 *     inner の opacity 0 / translateY(-8px) に遷移 → transition 完了 (450ms) 後に open 属性を外す
 *   - 開く時: open 属性をそのまま付与し、 CSS の [open] 状態の transition で展開
 *
 * details のキーボード操作 (Enter / Space) も summary に click イベントが届くので同じく動く。
 */
(function () {
  'use strict';

  var CLOSE_DURATION_MS = 450;

  function setup(details) {
    var summary = details.querySelector('summary');
    if (!summary) return;
    summary.addEventListener('click', function (e) {
      e.preventDefault();
      if (details.hasAttribute('open')) {
        details.classList.add('is-closing');
        window.setTimeout(function () {
          details.removeAttribute('open');
          details.classList.remove('is-closing');
        }, CLOSE_DURATION_MS);
      } else {
        details.setAttribute('open', '');
      }
    });
  }

  function init() {
    document.querySelectorAll('.faq-item').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
